import {Component, OnInit} from '@angular/core';
import {AppMainComponent} from './../app.main.component';

@Component({
    selector: 'app-config',
    template: `
        <div class="layout-config" [ngClass]="{'layout-config-active': app.configActive}" (click)="app.onConfigClick($event)">
            <a style="cursor: pointer" id="layout-config-button" class="layout-config-button" (click)="onConfigButtonClick($event)">
                <i class="pi pi-cog"></i>
            </a>
            <a style="cursor: pointer" class="layout-config-close" (click)="onConfigCloseClick($event)">
                <i class="pi pi-times"></i>
            </a>
            <div class="layout-config-content">
                <br/>
                <br/>
                <h5 >Estilo Campos</h5>
                <div class="p-formgroup-inline">
                    <div class="p-field-radiobutton">
                        <p-radioButton name="inputStyle" value="outlined" [(ngModel)]="app.inputStyle"
                                       inputId="inputStyle1"></p-radioButton>
                        <label for="inputStyle1">Con borde</label>
                    </div>
                    <div class="p-field-radiobutton">
                        <p-radioButton name="inputStyle" value="filled" [(ngModel)]="app.inputStyle" inputId="inputStyle2"></p-radioButton>
                        <label for="inputStyle2">Sin borde fondo gris</label>
                    </div>
                </div>

                <h5>Ubicación Menú</h5>
                <div class="p-formgroup-inline">
                    <div class="p-field-radiobutton">
                        <p-radioButton name="layoutMode" value="overlay" [(ngModel)]="app.layoutMode" inputId="mode1"></p-radioButton>
                        <label for="mode1">Vertical</label>
                    </div>
                    <div class="p-field-radiobutton">
                        <p-radioButton name="layoutMode" value="horizontal" [(ngModel)]="app.layoutMode" inputId="mode2"></p-radioButton>
                        <label for="mode2">Horizontal</label>
                    </div>
                </div>

                <h5>Menú Fondo</h5>
                <div class="p-formgroup-inline">
                    <div class="p-field-radiobutton">
                        <p-radioButton name="darkMenu" [value]="true" [(ngModel)]="app.darkMenu" inputId="darkMenu1"></p-radioButton>
                        <label for="darkMenu1">Oscuro</label>
                    </div>
                    <div class="p-field-radiobutton">
                        <p-radioButton name="darkMenu" [value]="false" [(ngModel)]="app.darkMenu" inputId="darkMenu2"></p-radioButton>
                        <label for="darkMenu2">Blanco</label>
                    </div>
                </div>

                <h5>Modo Pantalla</h5>
                <div class="p-formgroup-inline">
                    <div class="p-field-radiobutton">
                        <p-radioButton name="compactMode" [value]="true" [(ngModel)]="app.compactMode" inputId="compactMode1"
                                       (onClick)="changeThemeStyle($event, true)"></p-radioButton>
                        <label for="compactMode1">Compacto</label>
                    </div>
                    <div class="p-field-radiobutton">
                        <p-radioButton name="compactMode" [value]="false" [(ngModel)]="app.compactMode" inputId="compactMode2"
                                       (onClick)="changeThemeStyle($event, false)"></p-radioButton>
                        <label for="compactMode2">Estandard</label>
                    </div>
                </div>

                <h5>Fondo Menú Cabecera</h5>
                <div class="layout-themes">
                    <div *ngFor="let flatLayout of flatLayoutColors">
                        <a style="cursor: pointer" class="flat-layouts" (click)="changeLayout(flatLayout.label)"
                           [ngStyle]="{'background-color': flatLayout.color}">
                            <i class="pi pi-check" *ngIf="layout === flatLayout.label"></i>
                        </a>
                    </div>
                </div>

                <h5>Color Botones Principales</h5>
                <div class="layout-themes">
                    <div *ngFor="let theme of themes">
                        <a style="cursor: pointer" (click)="changeTheme(theme.label)">
                            <img src="assets/layout/images/configurator/theme/{{theme.image}}.svg" [alt]="theme.label"/>
                            <i class="pi pi-check" *ngIf="themeColor === theme.label"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    `
})
export class AppConfigComponent implements OnInit {

    themes: any[];

    themeColor = 'indigo';

    layout = 'orange-indigo';

    flatLayoutColors: any[];

    specialLayoutColors: any[];

    constructor(public app: AppMainComponent) {
    }

    ngOnInit() {
        this.flatLayoutColors = [
            {name: 'Grey Indigo', label: 'grey', color: '#757575'},
            {name: 'Indigo Pink', label: 'indigo', color: '#00418d'},
            {name: 'Orange Indigo', label: 'orange', color: '#FB8C00'},
        ];
        this.specialLayoutColors = [
        ];
        this.themes = [

            {image: 'indigo-pink', label: 'indigo'},
            {image: 'orange-indigo', label: 'orange'},
        ];

        this.changeLayout('indigo');
        this.changeTheme('orange-indigo');
    }

    changeTheme(theme) {
        this.themeColor = theme;
        if (this.app.compactMode) {
            this.changeStyleSheetsColor('theme-css', 'theme-' + theme + '-compact.css');
        } else {
            this.changeStyleSheetsColor('theme-css', 'theme-' + theme + '.css');
        }
    }

    changeLayout(layout) {
        this.layout = layout;
        this.changeStyleSheetsColor('layout-css', 'layout-' + layout + '.css');
    }

    changeThemeStyle(event, compactMode) {
        if (compactMode) {
            this.changeStyleSheetsColor('theme-css', 'theme-' + this.themeColor + '-compact.css');
        } else {
            this.changeStyleSheetsColor('theme-css', 'theme-' + this.themeColor + '.css');
        }
    }

    changeStyleSheetsColor(id, value) {
        const element = document.getElementById(id);
        const urlTokens = element.getAttribute('href').split('/');
        urlTokens[urlTokens.length - 1] = value;

        const newURL = urlTokens.join('/');

        this.replaceLink(element, newURL);
    }

    replaceLink(linkElement, href) {
        if (this.isIE()) {
            linkElement.setAttribute('href', href);
        } else {
            const id = linkElement.getAttribute('id');
            const cloneLinkElement = linkElement.cloneNode(true);

            cloneLinkElement.setAttribute('href', href);
            cloneLinkElement.setAttribute('id', id + '-clone');

            linkElement.parentNode.insertBefore(cloneLinkElement, linkElement.nextSibling);

            cloneLinkElement.addEventListener('load', () => {
                linkElement.remove();
                cloneLinkElement.setAttribute('id', id);
            });
        }
    }

    onConfigButtonClick(event) {
        this.app.configActive = !this.app.configActive;
        event.preventDefault();
    }

    onConfigCloseClick(event) {
        this.app.configActive = false;
        event.preventDefault();
    }

    isIE() {
        return /(MSIE|Trident\/|Edge\/)/i.test(window.navigator.userAgent);
    }
}
